import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Vite",
  "description": "모노레포에서 Vite를 사용하는 방법에 대해 자세히 알아봅니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Vite는 현대 웹 프로젝트를 위해 더 빠르고 간결한 개발 경험을 제공하는 것을 목표로 하는 빌드 도구입니다."
  }, {
    "heading": "빠른-시작",
    "content": "Turborepo에서 Vite를 빠르게 시작하려면 with-vite 예제를 사용하세요:"
  }, {
    "heading": "기존-저장소에-vite-애플리케이션-추가하기",
    "content": "npm create vite를 사용하여 패키지에 새 Vite 애플리케이션을 설정합니다. 저장소의 루트에서 다음을 실행하세요:"
  }, {
    "heading": "저장소와-통합하기",
    "content": "새 애플리케이션에 내부 패키지를 추가하려면 패키지 매니저를 사용하여 앱에 설치하세요:"
  }, {
    "heading": "저장소와-통합하기",
    "content": "패키지 매니저의 install 명령을 실행해야 합니다. 또한 저장소의 사용 사례에 맞게 package.json의 scripts를 업데이트해야 할 수도 있습니다."
  }, {
    "heading": "작업-사용자-정의",
    "content": "기본적으로 새 애플리케이션은 루트 turbo.json에 정의된 작업을 사용합니다. 새 애플리케이션에 대해 작업을 다르게 구성하려면 패키지 구성을 사용하세요."
  }, {
    "heading": "마이크로프론트엔드",
    "content": "Turborepo의 마이크로프론트엔드와 함께 Vite를 사용할 때는 하위 애플리케이션에 대해 basePath 속성을 설정해야 합니다. 이렇게 하면 이미지 및 CSS와 같은 자산이 올바른 애플리케이션으로 라우팅됩니다."
  }],
  "headings": [{
    "id": "빠른-시작",
    "content": "빠른 시작"
  }, {
    "id": "기존-저장소에-vite-애플리케이션-추가하기",
    "content": "기존 저장소에 Vite 애플리케이션 추가하기"
  }, {
    "id": "저장소와-통합하기",
    "content": "저장소와 통합하기"
  }, {
    "id": "작업-사용자-정의",
    "content": "작업 사용자 정의"
  }, {
    "id": "마이크로프론트엔드",
    "content": "마이크로프론트엔드"
  }]
};
import {PackageManagerTabs, Tab} from '#components/tabs';
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#빠른-시작",
  title: _jsx(_Fragment, {
    children: "빠른 시작"
  })
}, {
  depth: 2,
  url: "#기존-저장소에-vite-애플리케이션-추가하기",
  title: _jsx(_Fragment, {
    children: "기존 저장소에 Vite 애플리케이션 추가하기"
  })
}, {
  depth: 2,
  url: "#저장소와-통합하기",
  title: _jsx(_Fragment, {
    children: "저장소와 통합하기"
  })
}, {
  depth: 3,
  url: "#작업-사용자-정의",
  title: _jsx(_Fragment, {
    children: "작업 사용자 정의"
  })
}, {
  depth: 3,
  url: "#마이크로프론트엔드",
  title: _jsx(_Fragment, {
    children: "마이크로프론트엔드"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    p: "p",
    pre: "pre",
    span: "span",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://vitejs.dev/",
        children: "Vite"
      }), "는 현대 웹 프로젝트를 위해 더 빠르고 간결한 개발 경험을 제공하는 것을 목표로 하는 빌드 도구입니다."]
    }), "\n", _jsx(_components.h2, {
      id: "빠른-시작",
      children: "빠른 시작"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo에서 Vite를 빠르게 시작하려면 ", _jsxs(_components.a, {
        href: "https://github.com/vercel/turborepo/tree/main/examples/with-vite",
        children: [_jsx(_components.code, {
          children: "with-vite"
        }), " 예제"]
      }), "를 사용하세요:"]
    }), "\n", _jsxs(PackageManagerTabs, {
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " -e"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " with-vite"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " -e"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " with-vite"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " -e"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " with-vite"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun (Beta)",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "bunx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " -e"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " with-vite"
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "기존-저장소에-vite-애플리케이션-추가하기",
      children: "기존 저장소에 Vite 애플리케이션 추가하기"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://vitejs.dev/guide/#scaffolding-your-first-vite-project",
        children: _jsx(_components.code, {
          children: "npm create vite"
        })
      }), "를 사용하여 패키지에 새 Vite 애플리케이션을 설정합니다. 저장소의 루트에서 다음을 실행하세요:"]
    }), "\n", _jsxs(PackageManagerTabs, {
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " vite@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " apps/my-app"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " vite@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " apps/my-app"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " vite@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " apps/my-app"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun (Beta)",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "bun"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " vite@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " apps/my-app"
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "저장소와-통합하기",
      children: "저장소와 통합하기"
    }), "\n", _jsxs(_components.p, {
      children: ["새 애플리케이션에 ", _jsx(_components.a, {
        href: "/docs/core-concepts/internal-packages",
        children: "내부 패키지"
      }), "를 추가하려면 패키지 매니저를 사용하여 앱에 설치하세요:"]
    }), "\n", _jsxs(PackageManagerTabs, {
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/my-app/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  \"name\": \"my-app\","
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  \"dependencies\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+   \"@repo/ui\": \"workspace:*\""
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/my-app/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  \"name\": \"my-app\","
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  \"dependencies\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+   \"@repo/ui\": \"*\""
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/my-app/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " \"name\": \"my-app\","
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  \"dependencies\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+   \"@repo/ui\": \"*\""
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun (Beta)",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/my-app/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " \"name\": \"my-app\","
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  \"dependencies\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+   \"@repo/ui\": \"workspace:*\""
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["패키지 매니저의 install 명령을 실행해야 합니다. 또한 저장소의 사용 사례에 맞게 ", _jsx(_components.code, {
        children: "package.json"
      }), "의 ", _jsx(_components.code, {
        children: "scripts"
      }), "를 업데이트해야 할 수도 있습니다."]
    }), "\n", _jsx(_components.h3, {
      id: "작업-사용자-정의",
      children: "작업 사용자 정의"
    }), "\n", _jsxs(_components.p, {
      children: ["기본적으로 새 애플리케이션은 루트 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "에 정의된 작업을 사용합니다. 새 애플리케이션에 대해 작업을 다르게 구성하려면 ", _jsx(_components.a, {
        href: "/docs/reference/package-configurations",
        children: "패키지 구성"
      }), "을 사용하세요."]
    }), "\n", _jsx(_components.h3, {
      id: "마이크로프론트엔드",
      children: "마이크로프론트엔드"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/guides/microfrontends",
        children: "Turborepo의 마이크로프론트엔드"
      }), "와 함께 Vite를 사용할 때는 하위 애플리케이션에 대해 ", _jsx(_components.code, {
        children: "basePath"
      }), " 속성을 설정해야 합니다. 이렇게 하면 이미지 및 CSS와 같은 자산이 올바른 애플리케이션으로 라우팅됩니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/my-app/vite.config.ts",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "import"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " { defineConfig } "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "from"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " 'vite'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ";"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "export"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " default"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " defineConfig"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "({"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  base"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " '/thing'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "});"
            })
          })]
        })
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
